import classNames from 'classnames'
import { memo } from 'react'

import { RenderWhen } from 'clickNgo/components/renderWhen'
import { Translation } from 'cng-common/features/translations/components/translation'

import { getFieldDiffStatus } from './helpers/getFieldDiffStatus'
import { IPartnerDuplicatesDiffProps } from './models'

import styles from './PartnerDuplicatesDiff.module.scss'

export const PartnerDuplicatesDiff = memo<IPartnerDuplicatesDiffProps>(
  ({ difference, tableAdditionalColumns, partnerId, styleClasses }) => {
    const hasAdditonalColumns = tableAdditionalColumns && tableAdditionalColumns.length > 0

    return (
      <table className={classNames(styles.table, styleClasses?.table)}>
        <thead>
          <tr>
            <th colSpan={4} className={styles.title}>
              {/* Compare your result with company data */}
              <Translation text={'partner-apollo-compare-data'} span />
            </th>
          </tr>
          <tr className={styles.header}>
            <th>
              <Translation text={'partner-apollo-compare-table-col-field'} span />
            </th>
            <th>
              <Translation text={'partner-apollo-compare-table-col-result'} span />
            </th>
            <th>
              <Translation text={'partner-apollo-compare-table-col-state'} span />
            </th>
            <th>
              <Translation text={'partner-apollo-compare-table-col-status'} span />
            </th>
            <RenderWhen condition={hasAdditonalColumns}>
              {tableAdditionalColumns?.map((column) => {
                return (
                  <th key={column.title}>
                    <Translation text={column.title} span />
                  </th>
                )
              })}
            </RenderWhen>
          </tr>
        </thead>
        <tbody>
          {difference.map((differenceData) => {
            const { isDifferent, isEmpty, field, originalValue, comparedValue } = differenceData
            const iconClassNames = styles[getFieldDiffStatus({ isDifferent, isEmpty })]
            const bodyRowClassName = styles[`row__${getFieldDiffStatus({ isDifferent, isEmpty })}`]

            return (
              <tr key={field} className={bodyRowClassName}>
                <th>
                  <Translation text={field} span />
                </th>
                <td>{String(comparedValue)}</td>
                <td>{String(originalValue)}</td>
                <td className={styles.diff_icon}>
                  <strong className={iconClassNames}>
                    {getFieldDiffStatus({ isDifferent, isEmpty })}
                  </strong>
                </td>
                <RenderWhen condition={hasAdditonalColumns}>
                  <td>
                    {tableAdditionalColumns
                      ?.filter(({ checkVisibility }) => checkVisibility(differenceData))
                      .map(({ getContent }) => {
                        return getContent(differenceData, partnerId)
                      })}
                  </td>
                </RenderWhen>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
)
